export default __webpack_public_path__ + "static/media/deliland-flour-icon.ae755fe0.png";